import { render, staticRenderFns } from "./LeaderBoard.vue?vue&type=template&id=3de279a2&scoped=true"
import script from "./LeaderBoard.vue?vue&type=script&lang=js"
export * from "./LeaderBoard.vue?vue&type=script&lang=js"
import style0 from "./LeaderBoard.vue?vue&type=style&index=0&id=3de279a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de279a2",
  null
  
)

export default component.exports